import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { apiClient } from '@core/network/apiClient';
import { fetchAllPages } from '@core/network/paginate';
import type { SessionMineItem } from '@features/sessions/types/session.types';

export const sessionKeys = {
  all: ['sessions'] as const,
  mine: () => [...sessionKeys.all, 'mine'] as const,
};

/**
 * The caller's sessions with their summaries (GET /sessions/mine).
 *
 * Held longer than the 30s default because the history rail mounts on every
 * route, and this walks every page of the caller's sittings to fill it. Until
 * `GET /me/recents` exists that is the cost of a persistent rail, so it is paid
 * once per visit rather than once per navigation.
 */
export function useMySessions(): UseQueryResult<SessionMineItem[]> {
  return useQuery({
    queryKey: sessionKeys.mine(),
    queryFn: () => fetchAllPages<SessionMineItem>(apiClient, '/sessions/mine'),
    staleTime: 5 * 60_000,
  });
}
